<template>
  <v-layout justify-center id="reset-password">
    <v-flex xs12 sm6 md3>
      <v-img
        class="mb-5 mt-5"
        src="/img/plas-logo.png"
        contain
        :height="128"
      />
      <v-card>
        <v-toolbar color="primary" class="text-xs-center">
          <v-toolbar-title class="text-uppercase">
            {{ $t('RESET_PASSWORD') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <ValidationObserver
            ref="form"
            tag="form"
            @submit.prevent="resetPassword"
          >
            <ValidationProvider
                rules="required|min:8|max:60"
                vid="password"
                :name="$t('fields.password').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                type="password"
                v-model=" form.password"
                :counter="60"
                :label="$t('fields.password')"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider
                rules="required|confirmed:password|min:8|max:60"
                vid="password"
                :name="$t('fields.confirm_password').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                type="password"
                v-model=" form.password_confirmation"
                :counter="60"
                :label="$t('fields.confirm_password')"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions
          class="pl-3 pr-3 pt-1 pb-2"
        >
          <v-layout justify-center>
            <v-btn
              color="primary"
              @click="resetPassword()"
              :loading="loading"
              :disabled="loading"
            >{{ $t('RESET_PASSWORD') }}</v-btn>
          </v-layout>
        </v-card-actions>
        <v-card-actions
          class="pl-3 pr-3 pt-1 pb-3"
        >
          <router-link
            :to="{ name: 'login' }"
          >
            {{ $t("BACK_TO_LOGIN") }}
          </router-link>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapActions } from 'vuex';
  import { passwordService } from '../utils/services/password.service';

  export default {
    name: 'SendResetPassword',
    props: {
      token: String,
      email: String,
    },
    data() {
      return {
        form: {
          password: '',
          password_confirmation: '',
          token: this.token,
          email: this.email,
        },
        loading: false,
      };
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      async resetPassword() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
          this.loading = true;
            passwordService.reset(this.form).then(response => {
              this.showToast({ type: 'success', message: this.$t('PASSWORD_CHANGED') });
              const redirectUrl = response.data.redirect_url;
              if (redirectUrl) {
                window.location = redirectUrl;
              } else {
                this.$router.push({ name: 'login' });
              }
            }, error => {
              this.handleError(error, this.errors);
              this.loading = false;
            });
        }
      },
    },
  };
</script>

<style scoped>
</style>
